<template>
<div>


<template v-if="$store.state.questions.question.type=='text' || $store.state.questions.question.type=='longtext'">
<ContentHeader :title="$store.state.questions.question.name+': '+$store.state.languages.lang_phrases.kosullar"  url="QuestionCondition" :show_button="false" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>
</template>

<template v-else>
  <ContentHeader :title="$store.state.questions.question.name+': '+$store.state.languages.lang_phrases.kosullar"  url="QuestionCondition" :show_button="true" icon="plus" buttontype="primary" label="Yeni Ekle"></ContentHeader>
</template>

<!-- text-->
<template v-if="$store.state.questions.question.type=='text'">
<h4 class="text-primary">{{$store.state.languages.lang_phrases.text_turu_sorular_icin_kosul_secenegi_bulunmuyor}}</h4>
  
</template>
<!-- text-->

<!-- longtext-->
<template v-if="$store.state.questions.question.type=='longtext'">
<h4 class="text-primary">{{$store.state.languages.lang_phrases.uzun_text_turu_sorular_icin_kosul_secenegi_bulunmuyor}}</h4>
</template>
<!-- longtext-->



<template v-if="$store.state.questions.question.type!=='longtext' && $store.state.questions.question.type!=='text'">

<div class="mt-4">
<QuestionConditionLine v-for="item in items" :line="item"></QuestionConditionLine>
</div>
</template>

</div>
</template>

<script>
import QuestionConditionLine from "./QuestionConditionLine"
export default {

  name: 'QuestionConditions',
  components:{QuestionConditionLine},
  data () {
    return {
    	items:[],
    	loading:true,
    }
  },
  mounted()
  {
    console.log(this.$route.params.id)
    this.getData()
  },
  computed:{
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.getData()
      }
    }
  },
  methods:{
  	async getData()
    {
        this.items = await this.generalApiGetWithoutLoader("questionlists/inputfield_conditions/"+this.$route.params.id)
        console.log(this.items)

        this.loading = await false
    },   
  }
};
</script>

<style lang="css" scoped>
</style>